type ApiResult<T = unknown> = { data: T };

async function request<T>(method: string, url: string, body?: unknown): Promise<ApiResult<T>> {
  const isForm = body instanceof FormData;
  const response = await fetch(url, {
    method,
    credentials: 'include',
    headers: body === undefined || isForm ? undefined : { 'Content-Type': 'application/json' },
    body: body === undefined ? undefined : isForm ? body : JSON.stringify(body),
  });
  const contentType = response.headers.get('content-type') || '';
  const data = contentType.includes('application/json') ? await response.json() : await response.text();
  if (!response.ok) {
    const error = new Error(typeof data === 'object' && data && 'error' in data ? String((data as { error: unknown }).error) : `Request failed (${response.status})`) as Error & { response?: { data: unknown; status: number } };
    error.response = { data, status: response.status };
    throw error;
  }
  return { data: data as T };
}

export const api = {
  get: <T = unknown>(url: string) => request<T>('GET', url),
  post: <T = unknown>(url: string, body?: unknown) => request<T>('POST', url, body),
  put: <T = unknown>(url: string, body?: unknown) => request<T>('PUT', url, body),
  patch: <T = unknown>(url: string, body?: unknown) => request<T>('PATCH', url, body),
  delete: <T = unknown>(url: string, body?: unknown) => request<T>('DELETE', url, body),
  postForm: <T = unknown>(url: string, form: FormData) => request<T>('POST', url, form),
};

export type User = { id: string; email: string; role: 'user' | 'admin'; accountStatus: 'active' | 'suspended' };
export const auth = {
  async me() { return (await api.get<{ user: User | null }>('/api/auth/me')).data.user; },
  async requestCode(
    email: string,
    turnstileToken = '',
    legal: {acceptTerms:boolean;acceptPrivacy:boolean;acceptAiNotice:boolean} = {
      acceptTerms:false,acceptPrivacy:false,acceptAiNotice:false
    }
  ) {
    return (await api.post<{ ok:boolean;devCode?:string }>('/api/auth/request-code', {
      email,
      turnstileToken,
      ...legal,
    })).data;
  },
  async verifyCode(email: string, code: string) { return (await api.post<{ user: User }>('/api/auth/verify-code', { email, code })).data.user; },
  async logout() { await api.post('/api/auth/logout'); },
};
